import type { NameLocalizations } from './localization';
import { personNameLocalizations } from '../ui/locale/personNames';
import { fetchAuthedApiResponse } from './http';

export interface HeaderView { id: string; path: string; en: string; ar: string }
export interface HeaderDepartment extends HeaderView { views: HeaderView[] }
export interface HeaderSwitchers { employee_id: number; enabled: boolean; departments: HeaderDepartment[] }
export async function fetchHeaderSwitchers(signal?: AbortSignal): Promise<HeaderSwitchers> {
  const response = await fetchAuthedApiResponse('/employee/api/header-switchers', { signal, cache: 'no-store' });
  if (!response.ok) throw new Error('Header switchers unavailable');
  return response.json();
}
export async function resolveHeaderSwitch(department: string, view?: string): Promise<string> {
  const params = new URLSearchParams({ department });
  if (view) params.set('view', view);
  const response = await fetchAuthedApiResponse(`/employee/api/header-switchers/resolve?${params}`, { cache: 'no-store' });
  if (!response.ok) throw new Error('Header switch not authorized');
  return (await response.json()).path;
}

export interface HeaderEmployee { id: number; full_name?: string; name_localizations?: NameLocalizations; job_title?: string; profile_image_path?: string }

export async function fetchHeaderEmployee(signal?: AbortSignal): Promise<HeaderEmployee> {
  const response = await fetchAuthedApiResponse('/employee/api/profile', { signal, cache: 'no-store' });
  if (!response.ok) throw new Error('Employee profile unavailable');
  const data = await response.json();
  // Header queries retain only presentation fields from the current employee's profile.
  return { id: Number(data.id), full_name: data.full_name, ...(personNameLocalizations(data) ? { name_localizations: personNameLocalizations(data) } : {}), job_title: data.job_title, profile_image_path: data.profile_image_path };
}
